/** @jsx jsx */
import React, { useEffect, useRef } from 'react'
import { jsx } from 'theme-ui'
import { useScreenSize } from '../../lib/hooks'
import { FullBox } from '../../styles/components'

import Visualisation from '../../canvas'

export default props => {
  const containerEl = useRef(null)
  const canvas = useRef(null)
  const screenSize = useScreenSize()

  useEffect(() => {
    if (containerEl && !canvas.current) {
      canvas.current = new Visualisation({ el: containerEl.current })
    }
    return () => {
      if (canvas.current) {
        canvas.current.remove()
        canvas.current = null
      }
    }
  }, [containerEl])

  useEffect(() => {
    if (canvas.current) {
      canvas.current.updateSize({
        width: screenSize.width,
        height: screenSize.height,
      })
    }
  }, [screenSize.width, screenSize.height, canvas.current])

  return (
    <div
      ref={containerEl}
      style={{
        width: screenSize.width,
        height: screenSize.height,
      }}
      sx={{
        position: 'relative',
      }}
    />
  )
}
